import { LinearProgress } from "@material-ui/core";
import { BullIcon } from "../../shared/icons";
import { StyledProgressBar } from "./progress-bar.styles";

const MIN = 0;
const MAX = 100;

interface ProgressBarProps {
  value: number;
}

const porcentage = (value) => ((value - MIN) * 100) / (MAX - MIN);

export const ProgressBar = (props: ProgressBarProps) => {
  const { value } = props;

  return (
    <StyledProgressBar value={value} id="gameplan-wt-2">
      <span>{value}%</span>
      <div className="progressContainer">
        <LinearProgress
          variant="determinate"
          value={porcentage(value)}
          className="progressBar"
        />
        <BullIcon />
      </div>

      <span>100%</span>
    </StyledProgressBar>
  );
};
